import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { MatIconRegistry } from '@angular/material/icon';
import { RECAPTCHA_SETTINGS } from 'ng-recaptcha-2';
import { routes } from './app.routes';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { policyReducer } from './store/policy/policy.reducer';
import { PolicyEffects } from './store/policy/policy.effects';
import { authInterceptor } from './shared/interceptors/auth.interceptor';
import { ADDRESS_API_KEY } from '@pacificspecialtyinsurancecompany/psic-ng-components';
import { APP_CONFIG, AppConfig } from '../app.config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideStore({ policy: policyReducer }),
    provideEffects([PolicyEffects]),
    provideZonelessChangeDetection(),
    provideHttpClient(withInterceptors([authInterceptor]), withInterceptorsFromDi()),
    MatIconRegistry,
    { provide: RECAPTCHA_SETTINGS, useFactory: resolveRecaptchaKey, deps: [APP_CONFIG] },
    { provide: ADDRESS_API_KEY, useFactory: resolveAddressKey, deps: [APP_CONFIG] },
  ],
};

export function resolveAddressKey(config: AppConfig): string {
  return config.addressApiKey ?? '';
}

export function resolveRecaptchaKey(config: AppConfig) {
  return {
    siteKey: config.recaptchaSiteKey ?? '',
  };
}
